import { buildUrl } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import envelopesFields from '../../fields/envelopesFields';
import { ENVELOPES } from '../apiUrls';

/**
 * @param {Object} responseData
 * @param {Object[]} responseData.items
 * @param {string} responseData.items[].uuid
 * @param {string} responseData.items[].accessCode
 * @param {string} responseData.items[].createdAt
 * @param {string} responseData.items[].downloadServerIpAddressPort
 * @param {string} responseData.items[].organizationLegalName
 * @param {string} responseData.items[].posTerminalSerialNumber
 * @param {string} responseData.items[].scheduledEndDate
 * @param {string} responseData.items[].scheduledStartDate
 * @param {string} responseData.items[].sentToTerminalDate
 * @param {string} responseData.items[].status
 * @param {string} responseData.items[].updatedAt
 * @param {number} responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};
    const mappedItems = items.map(item => ({
        [envelopesFields.UUID.key]: item[envelopesFields.UUID.key],
        [envelopesFields.ACCESS_CODE.key]: item[envelopesFields.ACCESS_CODE.key],
        [envelopesFields.CREATED_AT.key]: item[envelopesFields.CREATED_AT.key],
        [envelopesFields.DOWNLOAD_SERVER_IP_ADDRESS_PORT.key]: item[envelopesFields.DOWNLOAD_SERVER_IP_ADDRESS_PORT.key],
        [envelopesFields.CLIENT_NAME.key]: item[envelopesFields.CLIENT_NAME.key],
        [envelopesFields.POS_TERMINAL_SERIAL_NUMBER.key]: item[envelopesFields.POS_TERMINAL_SERIAL_NUMBER.key],
        [envelopesFields.SCHEDULED_START_DATE.key]: item[envelopesFields.SCHEDULED_START_DATE.key],
        [envelopesFields.SCHEDULED_END_DATE.key]: item[envelopesFields.SCHEDULED_END_DATE.key],
        [envelopesFields.SENT_TO_TERMINAL_DATE.key]: item[envelopesFields.SENT_TO_TERMINAL_DATE.key],
        [envelopesFields.STATUS.key]: item[envelopesFields.STATUS.key],
        [envelopesFields.UPDATED_AT.key]: item[envelopesFields.UPDATED_AT.key]
    }));

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetEnvelopes = ({ query }, enabled) => {
    return {
        queryKey: [ENVELOPES.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(ENVELOPES.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetEnvelopes;